function findOutWhichEnv() {
  let env

  const host = window.location.hostname
  if (host.indexOf('.qa.hiplatform.com') !== -1 || host.indexOf('localhost') !== -1) {
    env = 'QA'
  } else if (host.indexOf('-hmg.hiplatform.com') !== -1) {
    env = 'HMG'
  } else {
    env = 'PROD'
  }

  return env
}

const ENVIRONMENT_TO_PATH = Object.freeze({
  QA: 'https://whatsapp-connect.qa.hiplatform.com',
  HMG: 'https://whatsapp-connect-hmg.hiplatform.com',
  PROD: 'https://whatsapp-connect.hiplatform.com',
})

const ENVIRONMENT_FILES = Object.freeze({
  QA: 'https://files.qa.directtalk.com.br',
  HMG: 'https://files-hmg.directtalk.com.br',
  PROD: 'https://files.directtalk.com.br',
})

/**
 * Caminho same-origin do widget do Flows. O nginx faz proxy de `/flows/` para a
 * distribuicao CloudFront do static-flows-bot (variavel HOST_FLOWS_CDN, importada
 * do export `WidgetDistributionDomainName` daquela stack), entao o dominio nao
 * precisa ser conhecido pelo bundle.
 *
 * Veja docs/adr/adr-002-resolucao-url-widget-flows.md
 */
const FLOWS_WIDGET_PATH = '/flows/flows-widget.js'

/**
 *
 * @param {('QA'|'HMG'|'PROD')} env
 * @returns
 */
function getEnvPath(env) {
  return ENVIRONMENT_TO_PATH[env]
}

/**
 *
 * @param {('QA'|'HMG'|'PROD')} env
 * @returns
 */
function getEnvFile(env) {
  return ENVIRONMENT_FILES[env]
}

export { FLOWS_WIDGET_PATH, findOutWhichEnv, getEnvFile, getEnvPath }
